// Custom button text for specific products
(function() {
  const customButtonProducts = {
    '7397965332553': 'Add To Cart - Sip for Strength',
    '7397966315593': 'Add To Cart - Sip for Strength',
    '7364439507017': 'Add to Cart – Drink With Purpose',
    '7397960220745': 'Add to Cart – Wear It Proud',
    '7397953175625': 'Add to Cart – Wear It Proud',
    '6976115408969': 'Add to Cart – Wellness with Purpose',
    '6976110723145': 'Add to Cart – Relief with Purpose',
    '6976116031561': 'Add to Cart – Sleep Better. Give Back.',
    '6976117342281': 'Add to Cart – Feel Better, Give Back'
  };
  
  // Check if we're on one of the target products
  const productMetaTag = document.querySelector('meta[property="og:url"]');
  let targetProductText = null;
  
  for (const [productId, buttonText] of Object.entries(customButtonProducts)) {
    if (productMetaTag && (productMetaTag.content.includes(productId) || document.body.innerHTML.includes(`"id":${productId}`))) {
      targetProductText = buttonText;
      break;
    }
  }
  
  if (targetProductText) {
    function updateButtonText() {
      const addToCartBtn = document.querySelector('.button--secondary div');
      if (addToCartBtn && addToCartBtn.textContent.trim() === 'Add to cart') {
        addToCartBtn.textContent = targetProductText;
      }
    }

    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateButtonText);
    } else {
      updateButtonText();
    }

    // Watch for variant changes
    const observer = new MutationObserver(updateButtonText);
    
    const checkButton = setInterval(function() {
      const buttonContainer = document.querySelector('.button--secondary');
      if (buttonContainer) {
        observer.observe(buttonContainer, { 
          childList: true, 
          subtree: true,
          characterData: true 
        });
        clearInterval(checkButton);
      }
    }, 100);
  }
})();